import BaseComponent from "../../../baseComponent.js";
import Animatable from "./animatable.jsx";
import StyleBox from "./style/styleBox.jsx";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator.js";
import style from "./textual.scss";
import style2 from "./animatable.scss";

const TextualController = require('./controller.js');

export default class TextualWidget extends BaseComponent {
  constructor(props) {
    super(props);

    this.legend = JSON.parse(JSON.stringify(this.props.widget.legends[0]));
    this.baseFontSize = 40;
    this.columns = [];
    this.selection = this.getInitialSelection();
    this.selectionStyle = {
      fontFamily: null,
      multiplier: null,
      bold: null,
      color: null
    };

    let initialState = [], selection = [];
    for (let i = 0; i < 25; i++) {
      initialState.push("0");
      selection.push(false);
    }

    this.state = {
      animatableValues: initialState,
      selection: selection,
      fontFamily: null,
      multiplier: null,
      bold: null,
      color: null,
      textLength: 7,
      selectionStyle: null,
      chartTypeParameters: this.getChartTypeParameters()
    };

    if (!this.legend.parameters.columns) {
      this.setDefaultColumns();
    }
  }

  getChartTypeParameters() {
    if (this.legend) {
      const chartParams = this.legend.parameters.chartTypeParameters;

      if (this.legend.parameters.suffix) {
        chartParams.suffix = this.legend.parameters.suffix;
        delete this.legend.parameters.suffix;
      }

      if (this.legend.parameters.animate != null) {
        chartParams.animate = this.legend.parameters.animate;
        delete this.legend.parameters.animate;
      }

      if (this.legend.parameters.groupSeparator != null) {
        chartParams.groupSeparator = this.legend.parameters.groupSeparator;
        delete this.legend.parameters.groupSeparator;
      }

      return {
        type: chartParams.type || "String",
        align: chartParams.align || (chartParams.type === "String" ? "left" : "right"),
        fontSizeType: chartParams.fontSizeType || "Relative",
        digits: chartParams.digits,
        decimalPlaces: chartParams.decimalPlaces,
        animate: chartParams.animate === undefined ? true : chartParams.animate,
        suffix: chartParams.suffix,
        groupSeparator: chartParams.groupSeparator
      }
    }
  }

  onLegendAdded(legend) {
    var _this = this;
    removeExistingDataField();
    addLegend(legend);

    // inner functions
    function removeExistingDataField() {
      if (_this.datasetId !== undefined) {
        WidgetService.removeDataFieldsForWidget(_this.props.model.id, [{
          datasetId: _this.datasetId,
          fieldId: _this.fieldId
        }]);
      }
    }

    function addLegend(legend) {
      _this.legend = legend;
      _this.textualController.setDataSource(_this.id, null, legend);
      _this.setDefaultColumns();
      _this.updateWidgetData();
      WidgetService.addComponentToWidget(_this.props.model.id, _this.textualController);
    }

    this.reSizeFont();
  }


  handleParameterChange(field, value) {
    const stateCopy = this.copyState();
    stateCopy.chartTypeParameters[field] = value;
    if (field === "fontSizeType") {
      stateCopy.selectionStyle.multiplier = value === "Absolute" ? 48 : 1;
    }
    this.setState(stateCopy);
    this.updateWidgetData(stateCopy);
  }

  updateWidgetData(stateCopy) {
    this.legend.parameters.columns = this.columns;
    this.legend.parameters.chartTypeParameters = stateCopy.chartTypeParameters;
    WidgetService.updateWidgetLegends(this.props.widget.id, [this.legend]);

    this.needForceUpdate = true;

    // preview widget in subscription popup cannot catch textual widget change
    this.publish(InternalEvent.Subscription.TEXTUAL_WIDGET_UPDATED);
  }


  componentWillUnmount() {
    this.textualController.destroy();
    this.unsubscribeAll();
  }

  setDefaultColumns() {
    this.columns = [];
    for (var i = 0; i < 7; i++) {
      this.columns.push({
        multiplier: 1,
        fontFamily: "Roboto",
        color: "#000",
        bold: false,
        italic: false
      });
    }
  }

  componentDidUpdate() {
    if (this.needForceUpdate && this.lastValue) {
      this.needForceUpdate = false;
      this.handleNewValue(this.lastValue);
    } else {
      this.reSizeFont();
    }
  }

  componentDidMount() {
    this.widgetId = this.props.model.id;
    this.componentId = UniqueIdGenerator.id();
    this.container = $(this.refs.container);
    this.styleBox = $(this.container.find(".tw-edit-box"));
    this.shouldShowStyleBox = false;
    this.animatables = this.container.find(".textual-animatable");
    this.selectables = this.container.find(".textual-selectable");

    this.textualController = new TextualController(this.componentId, this.widgetId, this.props.model.legends, this.props.togglePreloader);
    this.textualController.addChangeListener(value => this.handleNewValue(value));

    WidgetService.addComponentToWidget(this.props.model.id, this.textualController);

    this.container.css("opacity", 0);

    if (this.props.model.legends[0].parameters.columns) {
      this.initTextualData(this.props.model.legends[0]);
    }

    if (this.props.editMode) {
      this.subscribe(InternalEvent.App.DOCUMENT_CLICKED, (target) => {
        if ($(target).parents(".textual").length === 0 && !$(target).hasClass("textual")) {
          this.resetSelection();
          this.styleBox.slideUp();
          $(".option-list").hide();
        }
        this.isDragging = false;
      });
    }
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, payload => this.handleResize(payload));
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, payload => this.handleResize(payload));
    this.reSizeFont();
    this.setEditContainerSize();
    this.setStyleBoxPosition();
  }

  handleResize(data) {
    var _this = this;
    var widget;
    if (data.widget) {
      widget = data.widget;
    } else {
      widget = data[0]
    }

    var widgetId = $($(widget).children("div")[0]).attr("id");

    if (widgetId === this.widgetId) {
      if (typeof data === "object") {
        this.reSizeFont(data.width, data.height);
      } else {
        setTimeout(function () {
          _this.reSizeFont();
        }, 300);
      }
    }
  }

  initTextualData(legend) {
    for (var i = 0; i < legend.parameters.columns.length; i++) {
      this.columns.push({
        multiplier: legend.parameters.columns[i].multiplier,
        fontFamily: legend.parameters.columns[i].fontFamily,
        color: legend.parameters.columns[i].color,
        bold: legend.parameters.columns[i].bold,
        italic: legend.parameters.columns[i].italic
      });
    }
    this.setState({textLength: this.columns.length});
  }

  setDimension() {
    this.animatables = this.container.find(".textual-animatable");
    this.selectables = this.container.find(".textual-selectable");
    for (var i = 0; i < this.animatables.length; i++) {
      var animatable = $(this.animatables[i]);
      var valueElement = $(animatable.children()[0]);
      var width = valueElement.width();

      animatable.css({
        minWidth: width,
        maxWidth: width
      });
    }

    // seleactables should re-style after all animatables re-styling finished

    let selectHeight = $(this.refs.container).height();

    if (this.state.chartTypeParameters.fontSizeType === "Absolute") {
      const maxFontSize = this.getMaxMultiplier();
      selectHeight = maxFontSize * 2.2;
    }

    for (var i = 0; i < this.animatables.length; i++) {
      var animatable = $(this.animatables[i]);
      var selectable = $(this.selectables[i]);
      selectable.css({
        position: "absolute",
        minWidth: animatable.width(),
        minHeight: selectHeight,
        top: 0,
        left: animatable.position().left
      });
    }
  }

  reSizeFont(width, height) {
    this.animatables = $(this.refs.container).find(".textual-animatable");
    this.selectables = $(this.refs.container).find(".textual-selectable");

    if (this.state.chartTypeParameters.fontSizeType === "Relative") {
      var ratio = 1.8181;

      if (!this.props.editMode && this.props.model.title.length > 0) {
        $(this.refs.container).css("padding-top", "32px");
      }

      var containerHeight = height - 6 || $(this.refs.container).height() - 6,
        containerWidth = width - 12 || $(this.refs.container).width() - 12,
        totalMultiplier = this.getTotalMultiplier(),
        maxMultiplier = this.getMaxMultiplier();


      var baseFontSize = parseInt(containerWidth / totalMultiplier * ratio);

      if (baseFontSize * maxMultiplier > containerHeight) {
        baseFontSize = parseInt(containerHeight / maxMultiplier);
      }

      this.baseFontSize = baseFontSize;

      for (var i = 0; i < this.animatables.length; i++) {
        if (this.columns[i]) {
          var fontSize = this.columns[i].multiplier * this.baseFontSize;
          $($(this.animatables[i]).css("font-size", fontSize));
          $($(this.animatables[i]).find(".animatable__value")).css("font-size", fontSize);
        }
      }
    } else {
      for (let i = 0; i < this.animatables.length; i++) {
        if (this.columns[i]) {
          const fontSize = this.columns[i].multiplier * 2;
          $($(this.animatables[i]).css("font-size", fontSize));
          $($(this.animatables[i]).find(".animatable__value")).css("font-size", fontSize);
        }
      }
    }
    this.setDimension();
  }

  getTotalMultiplier() {
    var total = 0;
    for (var i = 0; i < this.columns.length; i++) total += this.columns[i].multiplier;
    return total;
  }

  getMaxMultiplier() {
    var max = 0;
    for (var i = 0; i < this.columns.length; i++) if (this.columns[i].multiplier > max) max = this.columns[i].multiplier;
    return max;
  }

  resetSelection() {
    this.selection = this.getInitialSelection();
    this.selectionStyle = {
      fontFamily: null,
      multiplier: null,
      bold: null,
      color: null
    };
    this.setState({
      selection: this.selection,
      fontFamily: null,
      multiplier: null,
      bold: null,
      color: null
    });
    this.shouldShowStyleBox = false;
  }

  getInitialSelection() {
    var selection = [];
    for (var i = 0; i < this.columns.length; i++) {
      selection.push(false);
    }
    return selection;
  }

  handleNewValue(value) {
    const isNumberType = this.state.chartTypeParameters.type === "Number";
    this.lastValue = value;
    if (value == null || value === "NaN") {
      return;
    }

    if (typeof value === "number") {
      if (isNaN(value) || value === Infinity) {
        return;
      }
      value = value + "";
    }

    if (!isNumberType && value.length > this.state.textLength) {
      this.onLengthChange(value.length);
    }

    value = isNumberType ? this.getFormattedNumber(value) : this.getFormattedString(value);
    value = this.addPrefixOrSuffix(value);

    if (isNumberType) {
      this.onLengthChange(value.length);
    }

    this.container.css("opacity", 1);
    var newValues = this.state.animatableValues.slice();

    for (var i = 0; i < newValues.length; i++) {
      if (i <= value.length - 1) {
        if (newValues.value !== value[i]) {
          newValues[i] = value[i];
        }
      }
    }
    this.setState({
      animatableValues: newValues
    });

    this.reSizeFont();
  }

  addPrefixOrSuffix(value) {
    if (this.state.chartTypeParameters.suffix) {
      value += this.state.chartTypeParameters.suffix;
    }
    return value;
  }

  /**
   * Applies numeric value to the format.
   * value: -15000.25, format: -###,###,###.###
   * return: #####-15,000.250
   * @param value
   * @returns {string}
   */
  getFormattedNumber(value) {
    const parameters = this.state.chartTypeParameters;
    const digits = parameters.digits || 1;
    const decimalPlaces = parameters.decimalPlaces !== undefined ? parameters.decimalPlaces : 4;
    const useGroupSeparator = parameters.groupSeparator;
    const format = this.getNumberFormat(digits, decimalPlaces, useGroupSeparator).split("");
    const isNegative = value.indexOf("-") > -1;

    let digitPart = value.split(".")[0];
    let decimalPart = value.split(".")[1] || "";

    digitPart = digitPart.split("");
    decimalPart = decimalPart.split("");

    const digitEndIndex = format.indexOf(".") === -1 ? format.length - 1 : format.indexOf(".") - 1;
    for (let i = digitEndIndex; i >= 1; i--) {
      if (digitPart.length === 0) {
        format[i] = "#";
      } else if (format[i] === "#") {
        format[i] = digitPart.pop() || "#";
      }
    }

    const decimalStartIndex = format.indexOf(".") === -1 ? format.length : format.indexOf(".") + 1;
    for (let i = decimalStartIndex; i < format.length; i++) {
      if (format[i] === "#") {
        format[i] = decimalPart.shift() || "0";
      }
    }

    if (isNegative) {
      // negative value has minus sign already, so remove it form the format
      format[0] = "#";
    }

    return format.join("");
  }

  /**
   * Returns a number format. ex) -##,###,###.##
   * Format always starts with "-"
   * @param digits
   * @param decimalPlaces
   * @param useGroupSeparator
   * @returns {string}
   */
  getNumberFormat(digits, decimalPlaces, useGroupSeparator) {
    let format = "";

    for (let i = 1; i <= digits; i++
    ) {
      if (useGroupSeparator && i % 3 === 0 && i !== digits) {
        format = ",#" + format;
      } else {
        format = "#" + format;
      }
    }

    if (decimalPlaces > 0) {
      format += ".";
      for (let i = 0; i < decimalPlaces; i++) {
        format += "#";
      }
    }
    return "-" + format;
  }

  getFormattedString(value) {
    const diff = this.columns.length - value.length;
    if (diff > 0) {
      value = '#'.repeat(diff) + value;
    } else if (diff < 0) {
      value = value.substring(0, this.columns.length);
    }
    return value;
  }

  handleMouseDown(position) {
    return (e) => {
      this.resetSelection();
      this.isDragging = true;
      this.select(position);
    }
  }

  handleMouseOver(position) {
    return (e) => {
      if (this.isDragging) {
        this.select(position);
      }
    }
  }

  handleMouseUp() {
    this.isDragging = false;
    if (this.shouldShowStyleBox) {
      this.styleBox.slideDown();
    }
  }

  select(position) {
    var style = this.columns[position];

    if (!this.selection[position]) {
      this.selection[position] = true;

      if (this.selectionStyle.fontFamily == null) this.selectionStyle.fontFamily = style.fontFamily;
      if (this.selectionStyle.multiplier == null) this.selectionStyle.multiplier = style.multiplier;
      if (this.selectionStyle.bold == null) this.selectionStyle.bold = style.bold;
      if (this.selectionStyle.color == null) this.selectionStyle.color = style.color;

      if (this.selectionStyle == null) {
        this.selectionStyle = {
          fontFamily: style.fontFamily,
          multiplier: style.multiplier,
          bold: style.bold,
          color: style.color
        }
      } else {
        var newSelectionStyle = {
          fontFamily: this.selectionStyle.fontFamily !== style.fontFamily ? "" : style.fontFamily,
          multiplier: this.selectionStyle.multiplier !== style.multiplier ? "" : style.multiplier,
          bold: this.selectionStyle.bold !== style.bold ? false : style.bold,
          color: this.selectionStyle.color !== style.color ? "" : style.color,
        };
        this.selectionStyle = newSelectionStyle;
        this.setState({selectionStyle: newSelectionStyle});
        this.shouldShowStyleBox = true;
      }
    }
  }

  onFontChange(type, value) {
    const stateCopy = this.copyState();
    stateCopy.selectionStyle[type] = value;
    var style = type;
    var styleValue = value;

    switch (type) {
      case "multiplier":
        stateCopy.multiplier = value;
        break;
      case "fontFamily":
        style = "font-family";
        break;
      case "bold":
        style = "font-weight";
        if (this.state.selectionStyle && this.state.selectionStyle.bold) {
          value = false;
          styleValue = "normal";
        } else {
          styleValue = "bold";
        }
        break;
    }

    for (var i = 0; i < this.selection.length; i++) {
      if (this.selection[i]) {
        this.columns[i][type] = value;
      }
    }

    if (type !== "multiplier") {
      for (var i = 0; i < this.selection.length; i++) {
        if (this.selection[i]) {
          if (style != "color") {
            $(this.animatables[i]).css(style, styleValue);
          }
          $($(this.animatables[i]).find(".animatable__value")).css(style, styleValue);
        }
      }
    }

    this.setState(stateCopy);
    this.updateWidgetData(stateCopy);
    this.setStyleBoxPosition();
  }

  onLengthChange(length, update) {
    const stateCopy = this.copyState();
    var diff = length - this.columns.length;
    for (var i = 0; i < Math.abs(diff); i++) {
      const lastColumn = this.columns[this.columns.length - 1];
      if (diff > 0) {
        this.columns.push({
          multiplier: lastColumn.multiplier,
          fontFamily: lastColumn.fontFamily,
          color: lastColumn.color,
          bold: lastColumn.bold,
          italic: lastColumn.italic
        });
      } else if (diff < 0) {
        this.columns.pop();
      }
    }

    if (update) {
      stateCopy.textLength = length;
      this.updateWidgetData(stateCopy);
    }
  }


  onFontSizeTypeChange(fontSizeType) {
    if (this.state.fontSizeType !== fontSizeType) {
      if (fontSizeType === "Absolute") {
        this.columns.forEach(c => c.multiplier = 48);

      } else {
        this.columns.forEach(c => c.multiplier = 1);
      }
      this.handleParameterChange("fontSizeType", fontSizeType);
    }
    this.setEditContainerSize(fontSizeType);
  }

  getAlign() {
    if (this.state.chartTypeParameters.align) {
      if (this.state.chartTypeParameters.align === 'left') {
        return 'flex-start';
      } else if (this.state.chartTypeParameters.align === 'center') {
        return 'center';
      } else {
        return 'flex-end';
      }
    } else {
      return this.state.chartTypeParameters.type === 'Number' ? 'flex-end' : 'flex-start';
    }
  }

  setEditContainerSize(fontSizeType) {
    if (this.props.editMode) {
      fontSizeType = fontSizeType || this.state.chartTypeParameters.fontSizeType;
      $("#edit-textual").css({
        height: fontSizeType === "Absolute" ? "initial" : "100px"
      });

      if (fontSizeType === "Relative") {
        $(this.refs.container).find(".tw-edit-box").css({
          top: '105px'
        });
      }
    }

  }

  setStyleBoxPosition() {
    if (this.props.editMode && this.state.chartTypeParameters.fontSizeType === "Absolute") {
      const fontSize = this.getMaxMultiplier();
      $(this.refs.container).find(".tw-edit-box").css({
        top: (fontSize * 2 + 20) + 'px'
      });
    }
  }

  render() {
    var animatables = [], selectables = [], styleBox, containerClasses = "textual";
    const params = this.state.chartTypeParameters;

    for (let i = 0; i < this.columns.length; i++) {
      let value = this.state.animatableValues[i];
      let hidden = false, display = true;

      // hide + sign
      if (params.type === "Number" && i === 0 && this.lastValue >= 0) {
        hidden = true;
      }

      // hide #
      if (value === "#") {
        value = "0";
        hidden = true;
      }

      // reserve space
      if (value === " ") {
        value = "|";
        hidden = true;
      }

      animatables.push(<Animatable value={value} key={i}
                                   animate={params.animate}
                                   hidden={hidden}
                                   display={display}
                                   data={this.columns[i]} baseFontSize={this.baseFontSize}/>);

      if (this.props.editMode) {
        var selectClasses = "textual-selectable";
        if (this.state.selection[i]) selectClasses += " textual-selectable--selected";
        selectables.push(<div key={"s-" + i} className={selectClasses}
                              onMouseDown={this.handleMouseDown(i)} onMouseUp={() => this.handleMouseUp()}
                              onMouseOver={this.handleMouseOver(i)}/>);
      }
    }

    if (this.props.editMode) {
      containerClasses += " textual-editable";
      styleBox = <StyleBox componentId={this.componentId}
                           onFontColorChange={this.onFontColorChange}
                           onFontChange={(t, v) => this.onFontChange(t, v)}
                           onLengthChange={length => this.onLengthChange(length, true)}
                           onDecimalPlacesChange={val => this.handleParameterChange("decimalPlaces", val)}
                           onDigitsChange={val => this.handleParameterChange("digits", val)}
                           onTypeChange={val => this.handleParameterChange("type", val)}
                           onAlignChange={val => this.handleParameterChange("align", val)}
                           onFontSizeTypeChange={this.onFontSizeTypeChange}
                           onAnimationChange={val => this.handleParameterChange("animate", val)}
                           onGroupSeparatorChange={val => this.handleParameterChange("groupSeparator", val)}
                           onSuffixChange={val => this.handleParameterChange("suffix", val)}
                           selectionStyle={this.state.selectionStyle}
                           textLength={this.state.textLength}
                           animate={params.animate}
                           decimalPlaces={params.decimalPlaces}
                           type={params.type}
                           digits={params.digits}
                           align={params.align}
                           fontSizeType={params.fontSizeType}
                           groupSeparator={params.groupSeparator || false}
                           suffix={params.suffix || ""}/>;
    }

    return (
      <div className={containerClasses} ref="container">
        {this.singleDroppable}
        <div style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: this.props.editMode ? "center" : this.getAlign(),
          width: "100%"
        }}>
          {animatables}
        </div>
        {selectables}
        {styleBox}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/textualWidget.jsx